// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 567 ? "layout-simple" : chunkId) + "." + {"96":"8faa2239","567":"1513d687"}[chunkId] + ".js";
};